module.exports = __webpack_public_path__ + "img/cases-detail-2.62e80671.png";